;(function (global) {
  function updateDpoJqSliderUI(control, input, min, max, current, opts) {
    if (!control) return false
    const slider = control.querySelector('.dpo-slider')
    if (!slider) return false
    const handle = slider.querySelector('.ui-slider-handle')
    const progress = control.querySelector('.dpo-slider-progress') || slider.querySelector('.dpo-slider-progress')
    const updateJqUi = opts && opts.updateJqUi !== undefined ? !!opts.updateJqUi : true
    const defer = opts && opts.defer !== undefined ? !!opts.defer : true

    if (updateJqUi) {
      try {
        const $ = global.jQuery || global.$
        if ($ && typeof $.fn?.slider === 'function') {
          const $slider = $(slider)
          try {
            $slider.slider('option', 'min', min)
          } catch (e) {}
          try {
            $slider.slider('option', 'max', max)
          } catch (e) {}
          try {
            $slider.slider('value', current)
          } catch (e) {}
        }
      } catch (jqErr) {}
    }

    let tries = 0
    const MAX_TRIES = 8
    const applyUI = () => {
      const denom = max - min
      const pct = denom > 0 ? Math.max(0, Math.min(100, ((current - min) / denom) * 100)) : 0
      if (handle && typeof handle.style?.setProperty === 'function') {
        let leftPct = pct
        try {
          const trackRect = slider.getBoundingClientRect()
          const handleRect = handle.getBoundingClientRect()
          const trackW = trackRect && trackRect.width ? trackRect.width : 0
          const handleW = handleRect && handleRect.width ? handleRect.width : handle.offsetWidth || 0
          const dimsOk = Number.isFinite(trackW) && Number.isFinite(handleW) && trackW > 0 && handleW > 0
          if (!dimsOk) {
            if (tries < MAX_TRIES && typeof requestAnimationFrame === 'function') {
              tries += 1
              requestAnimationFrame(applyUI)
            }
          } else if (trackW <= handleW) {
            leftPct = 50
          } else {
            const usableW = trackW - handleW
            const handleLeftPx = handleW / 2 + (pct / 100) * usableW
            leftPct = Math.max(0, Math.min(100, (handleLeftPx / trackW) * 100))
          }
        } catch (e) {
          /* best-effort */
        }
        handle.style.left = leftPct + '%'
      }
      if (progress && typeof progress.style?.setProperty === 'function') {
        progress.style.width = pct + '%'
        progress.style.opacity = pct > 0 ? '1' : '0'
      }
      if (handle && typeof handle.textContent !== 'undefined') {
        handle.textContent = String(current)
      }
      if (handle) {
        handle.setAttribute('aria-valuemin', String(min))
        handle.setAttribute('aria-valuemax', String(max))
        handle.setAttribute('aria-valuenow', String(current))
      }
    }
    applyUI()
    if (defer) {
      try {
        if (typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(applyUI)
        } else {
          setTimeout(applyUI, 0)
        }
      } catch (e) {
        setTimeout(applyUI, 0)
      }
    }
    return true
  }

  global.__dpoJqSliderLayout = { updateDpoJqSliderUI }
})(window)
